import React from 'react';
import { infoBadgePropTypes } from './InfoBadgePropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './InfoBadge.module.scss';
const InfoBadge = ({
  iconName,
  description,
  classname,
  children
}) => {
  if (!description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${children ? styles.rootHasChildren : ''} ${classname || ''}`
  }, iconName && /*#__PURE__*/React.createElement(Icon, {
    name: iconName,
    size: {
      width: 20,
      height: 20
    },
    classname: styles.rootIcon
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.rootDescription
  }, description), children);
};
export default InfoBadge;